import { render, staticRenderFns } from "./ActivityDuplicationsContainer.vue?vue&type=template&id=5df4c47a&lang=html&"
import script from "./ActivityDuplicationsContainer.vue?vue&type=script&lang=ts&"
export * from "./ActivityDuplicationsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports